// farehabor lightframe api 

let $mastheadBookButton = $('.masthead-booking');
let $bookbarButton = $('.fh-button');
let $bookButton = $('.fh-open'); 
let companyName = 'flagshipamsterdam'; 
let lang = document.documentElement.lang || 'nl-NL';

$mastheadBookButton.on('click', function() {
    let fh_flow = $(this).data('flow-id'),
        fh_item = $(this).data('item-id'),
        fh_shortname = $(this).data('account'),
        fh_ref = $(this).data('ref');

    openFHWidget(fh_flow, fh_item, fh_shortname, fh_ref);
});

$bookbarButton.on('click', function(e) {
    // prevent form from submitting to open widget
    e.preventDefault();

    let fh_flow = $(this).data('flow-id'),
        fh_item = $(this).data('item-id'), 
        fh_shortname = $(this).data('account'),
        fh_ref = $(this).data('ref'); 

    openFHWidget(fh_flow, fh_item, fh_shortname, fh_ref); 
}); 

$bookButton.on('click', function() {
    let fh_flow = $(this).data('flow-id'),
        fh_item = $(this).data('item-id'),
        fh_shortname = $(this).data('account');
        fh_ref = $(this).data('ref');

    openFHWidget(fh_flow, fh_item, fh_shortname, fh_ref);
})

function openFHWidget(flowID=false, views=false, shortname=false, ref=false) {
    // build arguments object for opening fareharbor widget
    let args = {};

    args.shortname = companyName;
    args.fallback = 'simple';
    args.fullItems = 'yes';
    args.language = lang;
    
    // add flow if declared
    if (flowID) {
        args.flow = flowID;
    }

    // add views if declared
    if (views) {
        views = { "item" : views}; 
        args.view = views; 
    }

    // set custom company/account name if declared
    if (typeof shortname !== 'undefined' && shortname) {
        args.shortname = shortname;
    }

    // set custom ref if declared
    if (typeof ref !== 'undefined' && ref) {
        args.ref = ref;
    }

    // open widget with args
    FH.open(args); 
}
